import { createSlice } from '@reduxjs/toolkit';
import IndustryService from '../../services/industry';

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: false,
  industries: []
};

const slice = createSlice({
  name: 'industry',
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
      state.error = false;
    },
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    getIndustriesSuccess(state, action) {
      state.isLoading = false;
      state.industries = action.payload || [];
    },
    upsertIndustrySuccess(state, action) {
      state.isLoading = false;
      const updated = action.payload;
      if (!updated) return;
      const idx = state.industries.findIndex((i) => i.code === updated.code);
      if (idx === -1) {
        state.industries.push(updated);
      } else {
        state.industries[idx] = updated;
      }
      state.industries.sort((a, b) => a.code.localeCompare(b.code));
    }
  }
});

export default slice.reducer;
export const { startLoading, hasError, getIndustriesSuccess, upsertIndustrySuccess } = slice.actions;

// ----------------------------------------------------------------------

export function getIndustries(includeDisabled = true) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    const response = await IndustryService.getList(includeDisabled);
    if (response.success) {
      dispatch(slice.actions.getIndustriesSuccess(response.data));
    } else {
      dispatch(slice.actions.hasError(response.errors || 'Failed to fetch industries'));
    }
    return response;
  };
}

export function createIndustry(payload) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    const response = await IndustryService.create(payload);
    if (response.success) {
      dispatch(slice.actions.upsertIndustrySuccess(response.data));
    } else {
      dispatch(slice.actions.hasError(response.errors || response.message || 'Failed to create industry'));
    }
    return response;
  };
}

export function updateIndustry(code, payload) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    const response = await IndustryService.update(code, payload);
    if (response.success) {
      dispatch(slice.actions.upsertIndustrySuccess(response.data));
    } else {
      dispatch(slice.actions.hasError(response.errors || response.message || 'Failed to update industry'));
    }
    return response;
  };
}

export function disableIndustry(code) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    const response = await IndustryService.disable(code);
    if (response.success) {
      dispatch(slice.actions.upsertIndustrySuccess(response.data));
    } else {
      dispatch(slice.actions.hasError(response.errors || response.message || 'Failed to disable industry'));
    }
    return response;
  };
}
